/**
 * The Supplies surface's static skeleton values. Shared by the cards
 * below, which render the design's layout as em-dashes until the data lands.
 */
import type { CSSProperties } from 'react';

export const EM_DASH = '—';

export const SKELETON_KEYS = ['a', 'b', 'c', 'd', 'e'] as const;
export const WEEK_COLS = ['Now', '+1 wk', '+2 wk', '+3 wk', '+4 wk', '+5 wk'] as const;
export const SCOPES = ['Region', 'Warehouse', 'Teacher'] as const;

export const cardHeading: CSSProperties = {
  fontSize: 13,
  letterSpacing: '0.04em',
  margin: 0,
};
